<template>
  <header v-show="!$route.meta.hideHeader">
    <Wrapper
      size="xl"
      boxed
      class="header__desktop"
    >
      <Flex justify="space-between">
        <Menu />
        <router-link to="/">
          <!-- {{ $store.state.wp.site.name }} -->
          <div class="logo" />
        </router-link>
        <WcMenu />
      </Flex>
    </Wrapper>

    <Wrapper
      size="xl"
      class="header__mobile"
    >
      <Flex
        justify="space-between"
        class="header__mobile--top"
        :class="$route.name == 'Index' ? 'header__mobile--top--home' : ''"
      >
        <div class="blank" />
        <router-link to="/">
          <div class="logo" />
        </router-link>
        <div
          class="burger"
          :class="{ burgerclosed: menuOpen }"
          @click="openMenu"
        />
      </Flex>
      <div
        v-if="menuOpen"
        class="header__mobile--menu"
      >
        <Menu />
        <WcMenu />
      </div>
    </Wrapper>
  </header>
</template>

<script>
import Menu from '@/components/ui/menu';
import WcMenu from '@/components/wc/wc-menu';

export default {
  name: 'Header',
  components: {
    Menu,
    WcMenu,
  },
  data() {
    return {
      menuOpen: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.menuOpen = false;
      }
    },
  },
  methods: {
    openMenu() {
      this.menuOpen = !this.menuOpen;
    },
  },
};
</script>

<style lang="scss">
</style>
